import React from "react";
import StepCard from "./StepCard";
import { recentWorkflowGuides } from "../../data/recentWorkflowGuides";

export default function RecentWorkflowGuide({ guideKey, darkMode = false }) {
  const guide = recentWorkflowGuides[guideKey];
  return (
    <div style={{ margin: "28px 0", textAlign: "left" }}>
      <h3 style={{ fontSize: "1.4rem", color: darkMode ? "#e2e8f0" : "#1e293b" }}>
        {guide.title}
      </h3>
      <p style={{ lineHeight: 1.7 }}>{guide.intro}</p>
      {guide.steps.map((step, index) => (
        <StepCard key={step.title} number={index + 1} title={step.title} darkMode={darkMode}>
          {step.paragraphs.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
        </StepCard>
      ))}
    </div>
  );
}
